<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-freeze-first-column`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.222 4h35.556C43.005 4 44 4.995 44 6.222v35.556A2.222 2.222 0 0141.778 44H6.222A2.222 2.222 0 014 41.778V6.222C4 4.995 4.995 4 6.222 4zM8 8v5.607L13.607 8H8zm0 14.607v-4.758L17.85 8H18v4.607l-10 10zm0 4.242v4.758l10-10v-4.758l-10 10zM8 40v-4.15l10-10v4.757L8.607 40H8zm4.85 0H18v-5.15L12.85 40zM22 8v32h18V8H22z"/></svg>
</template>
<script>

export default {
  name: 'IconFreezeFirstColumn',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
